import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import dsBankApi from "service/TichHopBank/dsBankApi";
import { pushNotification } from "utils/notifications";
export const ModalXoa = ({ toggleModal, isModalVisible, item, onSearch }) => {
  const [bDisable, setDisableButton] = useState(false);
  const DeleteBank = () => {
    setDisableButton(true);
    dsBankApi.deleteTaiKhoan({ idTaiKhoan: item.Id }).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        onSearch();
        toggleModal();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response.data, "error", "TOP_CENTER", 2000);
      }
    });
  };
  useEffect(() => {}, []);
  return (
    <Modal
      show={isModalVisible}
      backdrop={false}
      size="modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          Xác nhận xóa
        </h4>
        <button type="button" className="close-popup-new" onClick={toggleModal}>
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="body-detail-bc" style={{ color: "black" }}>
          <div class="form-money-2" style={{ marginBottom: "5px" }}>
            <div class="row">
              <div class="col-sm-6">
                <span style={{ color: "black" }}>
                  Bạn có chắc chắn muốn xóa không?
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer  className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={toggleModal}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
        <button
          className="btn btn-new-main btn-checknew"
          onClick={(e) => DeleteBank()}
          disabled={bDisable}
          type="submit"
        >
          <span>
            <img src="/app-assets/images/icon-save-v2-white.png" />
          </span>
          &nbsp; Xác nhận &nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
